export default __webpack_public_path__ + "static/Денежный поток 303+404_4-8ed2ed43f3d8b71adeff42ea4e4114ef.png";